var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("app-detail-header", {
        attrs: {
          "show-toggle": true,
          "show-delete": false,
          "show-save": false,
          "show-cancel": false,
          "show-new": false,
        },
        on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
      }),
      _c("div", { staticClass: "columns is-gapless" }, [
        _c(
          "div",
          { staticClass: "column is-narrow" },
          [
            _c("debtor-adjustment-list-side-menu", {
              on: { filter: _vm.filterList, reset: _vm.resetList },
              model: {
                value: _vm.filter,
                callback: function ($$v) {
                  _vm.filter = $$v
                },
                expression: "filter",
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "m-3" }, [
            _c(
              "article",
              { staticClass: "box" },
              [
                _c(
                  "bulma-table",
                  {
                    staticClass:
                      "table is-bordered is-striped is-narrow is-fullwidth",
                    attrs: {
                      columns: _vm.columns,
                      "page-index": _vm.filter.pageIndex,
                      "page-size": _vm.filter.pageSize,
                      "total-rows": _vm.totalRows,
                      "is-loading": _vm.isTableLoading,
                      "sort-column": _vm.filter.sortColumn,
                      "sort-order": _vm.filter.sortOrder,
                    },
                    on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
                  },
                  [
                    _vm._l(_vm.entitySummaries, function (entity, index) {
                      return _c(
                        "tr",
                        {
                          key: entity.invoiceId,
                          class: { "is-selected": _vm.selectedRow === index },
                          on: {
                            click: function ($event) {
                              return _vm.highlightSelected(index, $event)
                            },
                          },
                        },
                        [
                          entity.invoiceType === _vm.invoiceTypes.Adjustment
                            ? _c("td", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.generateUrl(entity.invoiceId),
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.edit(
                                          entity.invoiceId,
                                          entity.invoiceType,
                                          $event
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(entity.invoiceRef))]
                                ),
                              ])
                            : entity.invoiceType !==
                                _vm.invoiceTypes.Adjustment &&
                              entity.totalIncGst !== 0
                            ? _c("td", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.generateUrl(entity.invoiceId),
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.addnew(entity.invoiceId)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(entity.invoiceRef))]
                                ),
                              ])
                            : _c("td", [
                                _vm._v(" " + _vm._s(entity.invoiceRef) + " "),
                              ]),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.formatInvoiceType(
                                  entity.invoiceType
                                )
                              )
                            ),
                          ]),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.formatDateTimezone(
                                  entity.invoiceDate,
                                  _vm.$userInfo.locale
                                )
                              )
                            ),
                          ]),
                          _c("td", { staticClass: "has-text-right" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.formatNumber(
                                  entity.totalIncGst,
                                  _vm.$userInfo.locale
                                )
                              )
                            ),
                          ]),
                          _c("td", [_vm._v(_vm._s(entity.customerName))]),
                          _c("td", [_vm._v(_vm._s(entity.contactName))]),
                          _c("td", [_vm._v(_vm._s(entity.quoteNo))]),
                          entity.invoiceType === _vm.invoiceTypes.Adjustment
                            ? _c("td", { staticClass: "has-text-centered" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "button is-primary is-small is-inverted tooltip",
                                    attrs: {
                                      href: _vm.generateUrl(entity.invoiceId),
                                      "data-tooltip": "Click to edit",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.edit(
                                          entity.invoiceId,
                                          entity.invoiceType,
                                          $event
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "icon is-medium" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-lead-pencil mdi-24px",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ])
                            : entity.invoiceType !==
                                _vm.invoiceTypes.Adjustment &&
                              entity.totalIncGst !== 0
                            ? _c("td", { staticClass: "has-text-centered" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "button is-primary is-small is-inverted tooltip",
                                    attrs: {
                                      href: _vm.generateUrl(entity.invoiceId),
                                      "data-tooltip": "Click to add new",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.addnew(entity.invoiceId)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "icon is-medium" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-lead-pencil mdi-24px",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ])
                            : _c("td"),
                        ]
                      )
                    }),
                    _c("template", { slot: "empty" }, [
                      _c("section", { staticClass: "section" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "content has-text-grey has-text-centered",
                          },
                          [
                            _c("span", { attrs: { icon: "icon is-large" } }, [
                              _c("i", {
                                staticClass: "mdi mdi-48px mdi-emoticon-sad",
                              }),
                            ]),
                            _c("p", [_vm._v("Nothing")]),
                          ]
                        ),
                      ]),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }